<template>
  <section>

    <BodyText :body="message.body"></BodyText>
    
    <div  v-if="message.attachments.length != 0">
      <hr class="pb-0 mb-0 mt-2" />

      <div class="info-header mt-2">{{ $t("ATTACHMENTS") }}</div>

      <div class="mt-2">
        <span v-for="(item, index) in message.attachments" :key="index">
          <Attachment
            :item="item"
            :message_uuid="message.message_uuid"
            :user_uuid="user_uuid"
            :functionbox_uuid="functionbox_uuid"
            :index="index"
          ></Attachment>
        </span>
      </div>    
    </div>

    <MetadataSdk 
      v-if="showSdkMetadata" 
      :functionbox_uuid="functionbox_uuid"
      :metadata="message.creator.external_system.metadata"></MetadataSdk>        

  </section>
</template>
<script>
import Attachment from "@/components/View/Attachment";
import BodyText from "@/components/View/BodyText";
import MetadataSdk from "@/components/View/Information/Metadata/SdkMetadata";
export default {
  props: ["message","user_uuid", "functionbox_uuid","metadata"],
  components: {
    Attachment,
    BodyText,
    MetadataSdk
  },
  data() {
    return {
    };
  },
  methods: {
  },
  computed: {
    showSdkMetadata(){
      if(this.message.creator.external_system == undefined)
      {
        return false;
      }
      return this.message.creator.external_system.participantType == "SDK";
    }
  },
  watch: {},
  mounted: function () {},
};
</script>
<style></style>
